import OrganizerPermissions from "models/Permissions/AbstractPermissions/OrganizerPermissions"
import ParentPermissions from "models/Permissions/AbstractPermissions/ParentPermissions"

class PrivilegesPermissions {
    constructor({ 
        organizer = {},
        parent = {},
    }) {
        this.organizer = new OrganizerPermissions(organizer)
        this.parent = new ParentPermissions(parent)
    }
}

export default PrivilegesPermissions
